import React, { useEffect, useState } from 'react'
import queryString from 'query-string';
import { CustomGrid } from '../Components/CustomGrid'
import { Card } from '../Components/Cards/Card'
import { useRequestGet } from '../Hooks';
import { useLocation } from 'react-router-dom';
import { Pagination } from '../Components/Pagination/Pagination';


export const GridCards = ({slug = 'products/', filters = '', search='', pagination = false}) => {

    // const location = useLocation();

    // const { q = '' } = queryString.parse(location.search);

    const [products, setProducts] = useState([]);
    const [page, setPagination] = useState(1)
    
    const url = `${slug}${filters || search}&page=${page}`;
    
    const {data, isLoading, isError} =  useRequestGet(url);

    useEffect(() => {
        if (data && url !== 'products/'.trim()) {
            const products = JSON.parse(data);
            setProducts(products);
        } else {
            return setProducts([]);
        }

        return () => {
            setProducts([])
        }

    }, [data, url])

    return (
        <div>
            <CustomGrid
                arrayContent={
                    products?.results?.map((product) => (
                        <Card
                            key={product.id}
                            id={product.uuid}
                            image={product.image?.image}
                            title={product.name}
                            description={product.description}
                            price={product.price}
                        />
                    ))
                }
            />

            {
                pagination && products?.count > 10 && (
                    <div className='d-flex justify-content-center'>
                        <Pagination
                            totalPages={products?.count}
                            setPrevious={setPagination}
                            setNext={setPagination}
                        />
                    </div>
                )

            }
        </div>
    )
}
